import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=f72a3716&scoped=true&"
import script from "./HomeMain.vue?vue&type=script&lang=js&"
export * from "./HomeMain.vue?vue&type=script&lang=js&"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=f72a3716&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a3716",
  null
  
)

export default component.exports